/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ccsl_Export_Dialogue_Event_Group_LabelInputs */

const en_ccsl_export_dialogue_event_group_label = /** @type {(inputs: Ccsl_Export_Dialogue_Event_Group_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Combined Continuity & Dialogue Event Group`)
};

const fr_ccsl_export_dialogue_event_group_label = /** @type {(inputs: Ccsl_Export_Dialogue_Event_Group_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Groupe d'evenements continuite et dialogue`)
};

const de_ccsl_export_dialogue_event_group_label = /** @type {(inputs: Ccsl_Export_Dialogue_Event_Group_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kombinierte Veranstaltungsgruppe für Kontinuität und Dialog`)
};

const it_ccsl_export_dialogue_event_group_label = /** @type {(inputs: Ccsl_Export_Dialogue_Event_Group_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gruppo di eventi di continuità e dialogo combinati`)
};

const ru_ccsl_export_dialogue_event_group_label = /** @type {(inputs: Ccsl_Export_Dialogue_Event_Group_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Объединенная группа по организации мероприятий по обеспечению преемственности и диалогу`)
};

const es_ccsl_export_dialogue_event_group_label = /** @type {(inputs: Ccsl_Export_Dialogue_Event_Group_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grupo de eventos combinados de continuidad y diálogo`)
};

const zh_cn2_ccsl_export_dialogue_event_group_label = /** @type {(inputs: Ccsl_Export_Dialogue_Event_Group_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`联合连续性与对话活动组`)
};

const ja_ccsl_export_dialogue_event_group_label = /** @type {(inputs: Ccsl_Export_Dialogue_Event_Group_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`継続性と対話イベントグループ`)
};

const hi_ccsl_export_dialogue_event_group_label = /** @type {(inputs: Ccsl_Export_Dialogue_Event_Group_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`संयुक्त निरंतरता एवं संवाद कार्यक्रम समूह`)
};

const pt_pt2_ccsl_export_dialogue_event_group_label = /** @type {(inputs: Ccsl_Export_Dialogue_Event_Group_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grupo de Eventos Combinados de Continuidade e Diálogo`)
};

/**
* | output |
* | --- |
* | "Combined Continuity & Dialogue Event Group" |
*
* @param {Ccsl_Export_Dialogue_Event_Group_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ccsl_export_dialogue_event_group_label = /** @type {((inputs?: Ccsl_Export_Dialogue_Event_Group_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ccsl_Export_Dialogue_Event_Group_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ccsl_export_dialogue_event_group_label(inputs)
	if (locale === "de") return de_ccsl_export_dialogue_event_group_label(inputs)
	if (locale === "it") return it_ccsl_export_dialogue_event_group_label(inputs)
	if (locale === "ru") return ru_ccsl_export_dialogue_event_group_label(inputs)
	if (locale === "es") return es_ccsl_export_dialogue_event_group_label(inputs)
	if (locale === "zh-CN") return zh_cn2_ccsl_export_dialogue_event_group_label(inputs)
	if (locale === "ja") return ja_ccsl_export_dialogue_event_group_label(inputs)
	if (locale === "hi") return hi_ccsl_export_dialogue_event_group_label(inputs)
	if (locale === "pt-PT") return pt_pt2_ccsl_export_dialogue_event_group_label(inputs)
	return en_ccsl_export_dialogue_event_group_label(inputs)
});